const RunAsSoonAsWithDelay = (func, condition, delay) => {
    const interval = setInterval(() => {
        const conditionResult = condition();
        if (
            typeof condition === 'function' &&
            typeof conditionResult === 'boolean' &&
            conditionResult
        ) {
            func();
            clearInterval(interval);
        }
    }, delay);
};
export default RunAsSoonAsWithDelay;
